import { render, staticRenderFns } from "./MainSilder.vue?vue&type=template&id=2cef7013"
import script from "./MainSilder.vue?vue&type=script&lang=js"
export * from "./MainSilder.vue?vue&type=script&lang=js"
import style0 from "./MainSilder.vue?vue&type=style&index=0&id=2cef7013&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports